import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

export default class extends Controller {
  static values = {
    labels: Array,
    data: Array,
    colors: Array,
    hidden: { type: Array, default: [] }
  }

  connect() {
    this.canvas = this.element.querySelector('canvas')
    if (!this.canvas) return

    this.allLabels = [...this.labelsValue]
    this.allData = [...this.dataValue]
    this.allColors = [...this.colorsValue]
    this.hiddenIndices = new Set(this.hiddenValue)

    this.renderChart()
  }

  renderChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const { labels, data, colors } = this.visibleData()

    this.chart = new Chart(this.canvas, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          data,
          backgroundColor: colors,
          borderRadius: 4,
          barThickness: 28
        }]
      },
      plugins: [
        {
          id: 'barLabels',
          afterDatasetsDraw(chart) {
            const { ctx } = chart
            chart.data.datasets[0].data.forEach((value, index) => {
              const meta = chart.getDatasetMeta(0)
              const bar = meta.data[index]
              ctx.save()
              ctx.font = '12px system-ui, sans-serif'
              ctx.fillStyle = '#2d3748'
              ctx.textAlign = 'left'
              ctx.textBaseline = 'middle'
              ctx.fillText(
                value.toLocaleString(),
                bar.x + 6,
                bar.y
              )
              ctx.restore()
            })
          }
        }
      ],
      options: {
        indexAxis: 'y',
        maintainAspectRatio: false,
        layout: {
          padding: {
            right: 50
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              color: 'rgb(234, 236, 244)',
              drawBorder: false
            },
            ticks: {
              precision: 0
            }
          },
          y: {
            grid: {
              display: false,
              drawBorder: false
            }
          }
        }
      }
    })
  }

  visibleData() {
    const labels = []
    const data = []
    const colors = []

    this.allLabels.forEach((label, i) => {
      if (!this.hiddenIndices.has(i)) {
        labels.push(label)
        data.push(this.allData[i])
        colors.push(this.allColors[i])
      }
    })

    return { labels, data, colors }
  }

  toggle(event) {
    const index = parseInt(event.target.dataset.barIndex)
    if (event.target.checked) {
      this.hiddenIndices.delete(index)
    } else {
      this.hiddenIndices.add(index)
    }

    this.renderChart()
  }
}
